module.exports = {"pt-BR":{"components":{"proposal-overlay":{"info":{"title":"Detalhes do fornecedor"}}}}}